import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import feedback from './modules/feedback';
import auth from './modules/auth';
import lang from './modules/lang';

Vue.use(Vuex);

export default new Vuex.Store({
    /* strict: false, */
    modules: {
        feedback: feedback,
        auth: auth,
        lang: lang,
    },
    plugins: [
        createPersistedState({
            key: 'feedback-app',
            paths:['auth']
        })
    ]
})
